import React, { useEffect, useState, useRef } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import styles from './styles';
import withTheme from '../../../../hoc/withTheme';
import palette from '../../../../theme/Palette';
import withContent from '../../../../hoc/withContent';
import CtaButton from '../../../CtaButton';
import posed from 'react-pose';
import TopLeftShape from '../Projects/TopLeftShape';
import createFloatingParallaxOptions from '../../../../util/createFloatingParallaxOptions';
import { BackgroundAbstractShape } from '../../../../components/common';
import TextBubble from '../../../../components/TextBubble';

const Container = posed.div({
  enter: { staggerChildren: 50 },
});

const Title = posed.h1({
  open: { y: 0, opacity: 1 },
  closed: { y: 20, opacity: 0 },
});

const BusinessMan = posed.g({
  open: { x: 0, opacity: 1 },
  closed: { x: 50, opacity: 0 },
});

const Rocket = posed.g({
  open: { x: 0, y: 0, opacity: 1, delay: 400 },
  closed: { x: -50, y: 50, opacity: 0, delay: 400 },
});

const ContactPageShape = ({ classes, bIsDark, objContent, intContentIndex }) => {
  const [bIsOpen, setOpen] = useState(false);
  useEffect(() => {
    setOpen(true);
  }, []);

  const {
    title_contactpage: arrContactTitle = [],
    speech_bubble_contactpage: arrTextBubble = [],
    cta_text_projects: strCta,
  } = objContent[intContentIndex].data;

  const strFormattedContactTitle = arrContactTitle.map((objContent) => objContent.text).slice(0, 1);

  const handleClick = () => {
    const submitBtn = document.querySelector('#contactForm');
    submitBtn.scrollIntoView();
  };
  return (
    <Container className={classes.shape__containerContact}>
      <Title pose={bIsOpen ? 'open' : 'closed'} className={classes.header__titleContact}>
        {strFormattedContactTitle}
        <br />
      </Title>
      <div className={classes.contact__topLeftShape}>
        <TopLeftShape />
      </div>

      <div className={classes.header__ctaContact} onClick={handleClick}>
        <CtaButton strButtonText={strCta[0].text} strLink={'#contactForm'} />
      </div>

      <div className={classes.contact__text}>
        <TextBubble arrParagraphs={arrTextBubble} intSize={350} />
      </div>

      <div className={classes.contact__shapeBg}>
        <BackgroundAbstractShape
          intRotation="0"
          objParallaxOptions={createFloatingParallaxOptions('70', '540', '-80px')}
        />
      </div>
      <svg
        className={classes.contact__mainSvg}
        width="2476"
        height="1845"
        viewBox="0 0 2476 1845"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M971 123.5C971 124.881 969.881 126 968.5 126C967.119 126 966 124.881 966 123.5C966 122.119 967.119 121 968.5 121C969.881 121 971 122.119 971 123.5Z"
          fill="white"
        />
        <path
          d="M712 422.5C712 420.567 710.433 419 708.5 419C706.567 419 705 420.567 705 422.5C705 424.433 706.567 426 708.5 426C710.433 426 712 424.433 712 422.5Z"
          fill="white"
        />
        <path
          d="M742 413C742 411.895 741.105 411 740 411C738.895 411 738 411.895 738 413C738 414.105 738.895 415 740 415C741.105 415 742 414.105 742 413Z"
          fill="white"
        />
        <path
          d="M1087 114.5C1087 112.567 1085.43 111 1083.5 111C1081.57 111 1080 112.567 1080 114.5C1080 116.433 1081.57 118 1083.5 118C1085.43 118 1087 116.433 1087 114.5Z"
          fill="white"
        />
        <path
          d="M984.807 136C984.807 138.209 983.016 140 980.807 140C978.598 140 976.807 138.209 976.807 136C976.807 133.791 978.598 132 980.807 132C983.016 132 984.807 133.791 984.807 136Z"
          fill="white"
        />
        <path
          d="M675.499 324C675.499 320.687 672.59 318 669 318C672.59 318 675.499 315.315 675.499 312C675.499 315.315 678.41 318 682 318C678.41 318 675.499 320.687 675.499 324Z"
          fill="white"
        />
        <path
          d="M883 308C883 306.895 882.105 306 881 306C879.895 306 879 306.895 879 308C879 309.105 879.895 310 881 310C882.105 310 883 309.105 883 308Z"
          fill="white"
        />
        <path
          d="M1363 62.5C1363 63.8807 1361.88 65 1360.5 65C1359.12 65 1358 63.8807 1358 62.5C1358 61.1193 1359.12 60 1360.5 60C1361.88 60 1363 61.1193 1363 62.5Z"
          fill="white"
        />
        <path
          d="M1479 53.5C1479 51.567 1477.43 50 1475.5 50C1473.57 50 1472 51.567 1472 53.5C1472 55.433 1473.57 57 1475.5 57C1477.43 57 1479 55.433 1479 53.5Z"
          fill="white"
        />
        <path
          d="M1376.81 75C1376.81 77.2091 1375.02 79 1372.81 79C1370.6 79 1368.81 77.2091 1368.81 75C1368.81 72.7909 1370.6 71 1372.81 71C1375.02 71 1376.81 72.7909 1376.81 75Z"
          fill="white"
        />
        <path
          d="M1316 2.5C1316 3.88071 1314.88 5 1313.5 5C1312.12 5 1311 3.88071 1311 2.5C1311 1.11929 1312.12 0 1313.5 0C1314.88 0 1316 1.11929 1316 2.5Z"
          fill="white"
        />
        <path
          d="M874 187.5C874 188.881 872.881 190 871.5 190C870.119 190 869 188.881 869 187.5C869 186.119 870.119 185 871.5 185C872.881 185 874 186.119 874 187.5Z"
          fill="white"
        />
        <path
          d="M717 283.5C717 281.567 715.433 280 713.5 280C711.567 280 710 281.567 710 283.5C710 285.433 711.567 287 713.5 287C715.433 287 717 285.433 717 283.5Z"
          fill="white"
        />
        <path
          d="M976 114.5C976 112.567 974.433 111 972.5 111C970.567 111 969 112.567 969 114.5C969 116.433 970.567 118 972.5 118C974.433 118 976 116.433 976 114.5Z"
          fill="white"
        />
        <path
          d="M841 175C841 177.209 839.209 179 837 179C834.791 179 833 177.209 833 175C833 172.791 834.791 171 837 171C839.209 171 841 172.791 841 175Z"
          fill="white"
        />
        <path
          d="M716.499 386C716.499 382.687 713.59 380 710 380C713.59 380 716.499 377.315 716.499 374C716.499 377.315 719.41 380 723 380C719.41 380 716.499 382.687 716.499 386Z"
          fill="white"
        />
        <path
          d="M734.499 212C734.499 207.858 731.142 204.5 727 204.5C731.142 204.5 734.499 201.143 734.499 197C734.499 201.143 737.858 204.5 742 204.5C737.858 204.5 734.499 207.858 734.499 212Z"
          fill="white"
        />
        <path
          d="M924 370C924 368.895 923.105 368 922 368C920.895 368 920 368.895 920 370C920 371.105 920.895 372 922 372C923.105 372 924 371.105 924 370Z"
          fill="white"
        />
        <path
          d="M665 376C665 379.314 662.314 382 659 382C655.686 382 653 379.314 653 376C653 372.686 655.686 370 659 370C662.314 370 665 372.686 665 376Z"
          fill="white"
        />
        <path
          d="M1889 686.751C1889 889.695 1565.47 1031.8 1200.9 1146.63C662.898 1305.3 1115.96 529.129 765.545 506.163C323.107 418.472 1033.55 -74.0899 1153.9 128.433C1189.29 280.847 1865 193.55 1889 686.751Z"
          fill="url(#paint1_linear)"
        />
        <Rocket pose={bIsOpen ? 'open' : 'closed'} clipPath="url(#clip0)">
          <path
            d="M684 355.951C684 355.951 719.412 316.93 832.346 286.168C945.283 255.409 1036.2 218.631 1058.79 198L1063.3 205.277C1063.3 205.277 981.423 265.659 909.143 287.877C836.861 310.092 823.877 323.196 823.877 323.196C823.877 323.196 733.86 332.876 684 355.951Z"
            fill="url(#paint2_linear)"
          />
          <path
            d="M1081.3 219.866C1081.3 219.866 1029.56 271.949 1103 359.013C1103 359.013 1033.37 335.754 1025.2 331.719C1025.2 331.719 1023.2 268.489 1076.94 214.101L1081.3 219.866Z"
            fill="url(#paint3_linear)"
          />
          <path
            d="M1064.43 204.139C1064.43 204.139 1064.27 204.256 1063.96 204.489C1058.89 208.194 1014.3 240.437 967.873 262.243C918.556 285.408 837.993 303.258 819.545 323.764C819.545 323.764 909.144 318.068 934.366 319.591C934.366 319.591 990.836 282.371 1023.59 255.787C1056.34 229.204 1074.6 210.213 1074.6 210.213L1064.43 204.139Z"
            fill="url(#paint4_linear)"
          />
          <path
            d="M1079.3 212.117C1079.3 212.117 1032.62 267.179 1025.47 332.118C1025.47 332.118 945.283 319.967 934.366 319.591C934.366 319.591 989.19 281.554 1020.39 258.065C1046.36 238.508 1076.86 207.176 1076.86 207.176L1079.3 212.117Z"
            fill="url(#paint5_linear)"
          />
        </Rocket>
        <Rocket pose={bIsOpen ? 'open' : 'closed'} clipPath="url(#clip1)">
          <path
            d="M1096.72 161.053C1096.72 161.053 1072.53 183.662 1057.23 182.149C1053.14 181.745 1050.55 181.091 1048.86 182.884C1048.75 182.997 1066.63 197.725 1066.63 197.725L1096.72 161.053Z"
            fill="#45B6DC"
          />
          <path d="M1048.86 182.884L1066.6 197.698L1065.05 199.584L1047.31 184.77L1048.86 182.884Z" fill="#20325F" />
          <path d="M1080.55 209.696L1098.29 224.51L1096.74 226.396L1079 211.582L1080.55 209.696Z" fill="#20325F" />
          <path
            d="M1047.31 184.77L1056.65 192.572C1055.8 193.613 1054.25 193.749 1053.21 192.874L1047.65 188.239C1046.61 187.364 1046.45 185.811 1047.31 184.77Z"
            fill="#DD68E7"
          />
          <path
            d="M1111.3 173.221C1111.3 173.221 1093.75 201.379 1098.08 216.253C1099.23 220.223 1100.35 222.669 1098.92 224.68C1098.83 224.807 1081.14 209.838 1081.14 209.838L1111.3 173.221Z"
            fill="#5A88BD"
          />
          <path
            d="M1097.37 226.566L1088.02 218.764C1087.17 219.805 1087.32 221.358 1088.37 222.233L1093.92 226.868C1094.97 227.744 1096.51 227.607 1097.37 226.566Z"
            fill="#CE68E6"
          />
          <path
            d="M1112.45 156.923C1112.45 156.923 1098.89 156.728 1094.5 162.375C1090.1 168.023 1057.07 207.909 1057.07 207.909L1065.06 214.583"
            fill="#D4DAFB"
          />
          <path
            d="M1112.45 156.923C1112.45 156.923 1115.17 170.32 1110.48 175.721C1105.79 181.12 1073.05 221.257 1073.05 221.257L1065.06 214.583"
            fill="#D4DAFB"
          />
          <path
            d="M1106.65 172.24C1104.83 174.45 1101.56 174.738 1099.34 172.882C1097.11 171.027 1096.79 167.731 1098.6 165.52C1100.42 163.31 1103.69 163.023 1105.92 164.878C1108.14 166.734 1108.47 170.03 1106.65 172.24Z"
            fill="#7044D0"
          />
        </Rocket>
        <ellipse cx="1195" cy="310.5" rx="63" ry="63.5" fill="url(#paint6_linear)" />
        <path
          d="M944 218.5C944 219.881 942.881 221 941.5 221C940.119 221 939 219.881 939 218.5C939 217.119 940.119 216 941.5 216C942.881 216 944 217.119 944 218.5Z"
          fill="white"
        />
        <path
          d="M787 314.5C787 312.567 785.433 311 783.5 311C781.567 311 780 312.567 780 314.5C780 316.433 781.567 318 783.5 318C785.433 318 787 316.433 787 314.5Z"
          fill="white"
        />
        <path
          d="M1046 145.5C1046 143.567 1044.43 142 1042.5 142C1040.57 142 1039 143.567 1039 145.5C1039 147.433 1040.57 149 1042.5 149C1044.43 149 1046 147.433 1046 145.5Z"
          fill="white"
        />
        <path
          d="M911 206C911 208.209 909.209 210 907 210C904.791 210 903 208.209 903 206C903 203.791 904.791 202 907 202C909.209 202 911 203.791 911 206Z"
          fill="white"
        />
        <path
          d="M786.499 417C786.499 413.687 783.59 411 780 411C783.59 411 786.499 408.315 786.499 405C786.499 408.315 789.41 411 793 411C789.41 411 786.499 413.687 786.499 417Z"
          fill="white"
        />
        <path
          d="M804.499 243C804.499 238.858 801.142 235.5 797 235.5C801.142 235.5 804.499 232.143 804.499 228C804.499 232.143 807.858 235.5 812 235.5C807.858 235.5 804.499 238.858 804.499 243Z"
          fill="white"
        />
        <path
          d="M993.499 145C993.499 139.754 989.247 135.5 984 135.5C989.247 135.5 993.499 131.248 993.499 126C993.499 131.248 997.753 135.5 1003 135.5C997.753 135.5 993.499 139.754 993.499 145Z"
          fill="white"
        />
        <path
          d="M735 407C735 410.314 732.314 413 729 413C725.686 413 723 410.314 723 407C723 403.686 725.686 401 729 401C732.314 401 735 403.686 735 407Z"
          fill="white"
        />
        <BusinessMan pose={bIsOpen ? 'open' : 'closed'} clipPath="url(#clip2)">
          <path
            d="M839.065 761.73C798.942 760.33 760.73 747.298 724.262 733.052C687.793 718.806 651.609 702.999 612.45 695.407C587.26 690.549 558.459 689.857 538.163 703.446C518.638 716.528 512.32 739.108 508.934 760.06C506.421 775.825 504.879 792.416 511.876 807.169C516.728 817.417 525.35 826.029 531.309 835.847C552.057 869.991 537.392 912.098 514.909 945.441C504.367 961.079 492.133 976 483.996 992.676C475.859 1009.35 472.089 1028.4 479.211 1045.38C486.267 1062.25 503.085 1074.86 521.303 1083.75C558.308 1101.81 601.908 1106.98 644.427 1109.9C738.549 1116.38 833.165 1113.58 927.539 1110.75C962.457 1109.7 997.535 1108.65 1031.89 1103.21C1050.97 1100.19 1070.67 1095.4 1084.53 1083.81C1102.12 1069.13 1106.46 1044.27 1094.68 1025.86C1074.91 994.978 1020.28 987.303 1006.46 954.162C998.859 935.918 1006.67 915.598 1017.71 898.687C1041.42 862.417 1081.15 830.55 1083.24 789.034C1084.68 760.55 1065.58 732.015 1036.05 718.527C1005.09 704.399 962.164 706.179 939.329 729.568C915.815 753.709 874.486 762.97 839.065 761.73Z"
            fill="url(#paint7_linear)"
          />
          <path
            d="M690.721 1334.37C831.399 1334.37 945.441 1318.84 945.441 1299.68C945.441 1280.53 831.399 1265 690.721 1265C550.042 1265 436 1280.53 436 1299.68C436 1318.84 550.042 1334.37 690.721 1334.37Z"
            fill="#1B1844"
          />
          <path
            d="M822.238 832.794C822.238 832.794 814.353 817.13 815.417 812.474C816.481 807.818 809.87 797.874 809.87 797.874L810.297 781.375C810.297 781.375 809.383 783.062 804.624 784.538C804.222 784.007 803.786 783.484 803.333 782.986C801.61 781.179 799.693 779.57 797.618 778.187L789.238 759.984L781.135 747.492C781.135 747.492 768.356 721.344 755.158 715.575L753.08 711.484C753.148 711.443 753.199 711.378 753.222 711.302C753.245 711.226 753.239 711.143 753.205 711.071L751.094 706.912C751.056 706.841 750.993 706.785 750.917 706.757C750.841 706.729 750.758 706.73 750.683 706.761L748.664 702.779C747.892 697.62 745.878 692.729 742.798 688.533C742.588 688.238 742.362 687.968 742.144 687.69L745.429 687.571C748.312 687.462 751.529 687.209 753.465 685.041C754.159 684.233 754.671 683.283 754.965 682.257C755.214 681.453 755.377 680.625 755.451 679.786C755.451 679.66 755.451 679.533 755.451 679.415C755.451 679.128 755.451 678.847 755.451 678.571C755.451 678.344 755.451 678.124 755.451 677.897C755.451 677.669 755.451 677.534 755.451 677.357C755.451 677.18 755.359 676.775 755.309 676.513C755.309 676.404 755.309 676.294 755.242 676.184C755.172 675.854 755.085 675.527 754.982 675.206C754.957 675.143 754.938 675.078 754.923 675.012C754.806 674.675 754.68 674.337 754.538 674.008C754.515 673.965 754.495 673.92 754.479 673.873C754.328 673.544 754.161 673.224 753.985 672.912L753.934 672.81C753.873 672.68 753.803 672.553 753.725 672.431C751.454 668.838 747.465 666.737 743.669 664.84C740.127 662.965 736.491 661.276 732.775 659.779C718.961 654.564 703.701 654.781 690.038 660.386C688.689 660.9 687.411 661.586 686.234 662.427C684.594 663.824 683.193 665.483 682.086 667.336L675.592 676.994C674.684 678.169 673.974 679.485 673.488 680.891C672.273 685.48 676.086 690.077 675.659 694.809C675.441 697.162 674.184 699.321 673.941 701.674C673.631 704.711 675.03 707.638 676.396 710.379L685.689 728.936C685.195 731.373 684.65 733.87 684.055 736.283C679.773 740.736 678.332 743.165 677.938 744.481L677.812 744.549C676.964 745.1 676.235 745.817 675.667 746.657L666.835 755.295C666.835 755.295 651.483 759.31 648.29 764.396C648.29 764.396 624.198 763.333 624.408 797.199C624.408 797.199 623.344 809.902 622.732 811.597C622.12 813.292 622.732 830.432 622.732 830.432L622.447 865.15C622.447 865.15 621.525 883.563 622.447 890.125C623.369 896.687 624.433 921.663 624.433 921.663C624.433 921.663 630.19 946.006 628.062 954.685C626.017 962.994 628.062 981.162 631.413 981.238C632.05 982.562 632.779 983.212 633.575 982.841C633.922 982.689 634.277 982.56 634.64 982.453V1003.19C634.64 1003.19 630.492 1032.25 635.142 1037.78C632.059 1042.2 628.439 1049.74 627.517 1051.72L594.919 1049.96L590.771 1051.13L586.967 1052.2L584.663 1105.57L585.584 1105.63L585.517 1107.26L587.696 1107.42L584.663 1161.17L629.788 1164.91C627.802 1169.39 625.497 1174.18 624.601 1174.65C622.925 1175.49 619.271 1172.96 618.416 1174.01C617.562 1175.05 615.006 1176.34 612.023 1175.69C609.039 1175.05 607.12 1178.44 607.12 1178.44C607.12 1178.44 607.556 1178.83 608.21 1179.55C603.366 1178.96 597.241 1181.57 593.914 1183.26C592.422 1184.02 591.492 1184.58 591.492 1184.58H582.693L587.529 1215.63L590.939 1217.98L591.777 1242.44C591.777 1242.44 605.419 1284.77 611.671 1284.5C612.077 1284.48 612.475 1284.38 612.838 1284.19C613.201 1284.01 613.52 1283.75 613.774 1283.43C617.126 1279.54 614.805 1266.15 614.805 1266.15V1243.86C614.805 1243.86 619.916 1241.6 619.347 1239.91C618.777 1238.21 627.592 1219.66 628.38 1217.98C628.403 1217.96 628.421 1217.94 628.433 1217.92C628.444 1217.9 628.449 1217.87 628.447 1217.84C628.447 1215.94 632.285 1213.82 632.067 1212.98C631.849 1212.13 641.452 1206.84 642.123 1202.18C642.793 1197.52 649.153 1200.06 649.153 1200.06L657.248 1190.7C657.491 1202.11 657.952 1210.1 658.748 1212.12C662.586 1221.87 664.078 1237.11 664.078 1237.11C664.078 1237.11 661.732 1248.75 664.078 1252.56C665.519 1254.89 668.871 1257.39 671.201 1259.45C668.779 1266.84 669.123 1282.55 669.123 1282.55V1291.57L687.03 1296.63C687.03 1296.63 687.592 1292.12 688.446 1292.12C689.301 1292.12 700.672 1300.87 700.672 1300.87C700.672 1300.87 744.449 1301.43 755.527 1300.87C759.716 1300.66 760.856 1298.84 760.211 1296.65C759.147 1293 753.172 1288.27 747.859 1287.9C739.328 1287.34 728.527 1278.31 728.527 1278.31C728.527 1278.31 729.365 1276.33 724.831 1273.51C721.697 1271.57 713.024 1263.72 707.661 1259.12C707.913 1258.78 708.172 1258.43 708.415 1258.06C708.415 1258.06 701.167 1247.94 702.667 1243.45C704.167 1238.96 702.022 1232.49 702.022 1232.49C702.022 1232.49 697.974 1219.99 697.974 1213.64C697.974 1209.62 697.371 1186.74 696.935 1170.51L700.672 1170.82L700.748 1169.2L702.424 1169.35L718.27 1170.82L717.784 1153.77C725.418 1150.4 731.77 1147.27 734.401 1145.27C743.351 1138.52 751.027 1138.08 751.027 1138.08C751.027 1138.08 769.144 1128.34 771.917 1124.32C774.691 1120.29 774.431 1091.08 774.431 1091.08L772.94 1028.48V1028.43C772.94 1028.43 771.666 998.167 769.102 991.604C768.163 989.175 765.842 981.078 763.303 971.833C764.762 971.682 766.236 971.744 767.677 972.019C767.769 974.279 767.828 975.831 767.828 976.363C767.828 979.956 772.94 983.009 772.94 983.009L769.32 902.035V846.947C780.482 850.524 807.473 851.637 807.473 851.637C826.922 850.608 822.238 832.794 822.238 832.794ZM716.954 763.223H716.896C717.292 761.1 717.81 759.002 718.446 756.939L716.954 763.223ZM643.698 1040.96C650.31 1042.05 657.944 1041.73 658.522 1040.44C658.581 1040.32 658.656 1040.09 658.757 1039.79C658.966 1040.16 659.167 1040.54 659.377 1040.93L658.732 1053.14V1053.42L636.944 1052.24C638.469 1045.71 641.352 1042.52 643.698 1040.96ZM716.326 1102.58L715.764 1082.8C716.737 1079.16 717.608 1075.85 718.354 1073.02C718.689 1075.37 718.974 1077.54 719.192 1079.54C721.253 1098.3 718.211 1101.97 716.326 1102.58ZM778.336 806.03C777.088 806.511 772.336 803.5 767.828 800.379C767.828 799.805 767.87 799.24 767.895 798.692C768.532 785.778 747.641 777.74 741.247 776.255C739.696 775.852 738.19 775.287 736.756 774.568C733.349 772.87 730.037 770.986 726.834 768.925L726.918 768.681C726.918 768.681 718.672 763.426 718.496 756.872C720.375 750.911 722.747 745.118 725.586 739.555C725.745 739.226 725.921 738.88 726.088 738.551C729.985 737.332 733.623 735.392 736.814 732.833C738.097 749.702 762.348 764.219 762.348 764.219L764.937 768.436L765.549 769.431C764.242 770.207 763.613 770.832 764.057 771.194C765.901 772.679 770.359 781.08 772.202 784.631C772.705 785.592 773.04 786.191 773.04 786.191C773.04 786.191 777.004 797.047 779.275 806.131C778.973 806.004 778.641 805.969 778.32 806.03H778.336Z"
            fill="url(#paint8_linear)"
          />
          <path
            d="M787.705 762.279L787.42 762.658L786.448 763.966L767.803 777.225L763.848 770.68L761.334 766.462C761.334 766.462 724.169 744.026 740.15 722.399C756.13 700.772 779.744 749.812 779.744 749.812L787.705 762.279Z"
            fill="#C08B93"
          />
          <path
            d="M750.206 709.445C750.127 709.287 749.936 709.223 749.779 709.303C749.621 709.382 749.558 709.575 749.637 709.733L751.71 713.877C751.789 714.035 751.981 714.098 752.138 714.019C752.295 713.939 752.358 713.746 752.279 713.588L750.206 709.445Z"
            fill="#3A3768"
          />
          <path
            d="M728.929 715.238L728.922 715.242C728.835 715.286 728.8 715.392 728.844 715.48L729.462 716.715C729.506 716.803 729.611 716.838 729.698 716.794L729.706 716.79C729.793 716.746 729.827 716.639 729.784 716.552L729.166 715.317C729.122 715.229 729.016 715.194 728.929 715.238Z"
            fill="#3A3768"
          />
          <path
            d="M730.622 718.164C730.572 718.064 730.451 718.023 730.352 718.074C730.252 718.124 730.212 718.246 730.262 718.346L731.435 720.689C731.484 720.788 731.605 720.829 731.705 720.778C731.804 720.728 731.844 720.606 731.794 720.506L730.622 718.164Z"
            fill="#3A3768"
          />
          <path
            d="M732.429 721.81C732.381 721.715 732.265 721.676 732.17 721.724C732.075 721.772 732.037 721.889 732.085 721.985L733.276 724.365C733.324 724.461 733.44 724.5 733.535 724.451C733.63 724.403 733.668 724.286 733.62 724.191L732.429 721.81Z"
            fill="#3A3768"
          />
          <path
            d="M743.704 701.309L728.047 709.246C727.121 709.715 726.748 710.851 727.214 711.783L744.982 747.296C745.448 748.228 746.577 748.603 747.503 748.134L763.16 740.197C764.086 739.728 764.458 738.592 763.992 737.66L746.225 702.147C745.758 701.215 744.63 700.84 743.704 701.309Z"
            fill="#3A3768"
          />
          <path
            d="M741.701 703.564C741.611 703.609 741.531 703.671 741.465 703.747C741.4 703.823 741.35 703.912 741.319 704.008C741.288 704.104 741.276 704.205 741.284 704.305C741.292 704.406 741.319 704.503 741.365 704.593L741.433 704.736C741.479 704.827 741.507 704.925 741.515 705.026C741.523 705.127 741.511 705.229 741.48 705.325C741.449 705.422 741.399 705.511 741.333 705.588C741.268 705.665 741.187 705.728 741.097 705.774L733.036 709.856C732.947 709.903 732.85 709.931 732.75 709.939C732.65 709.947 732.55 709.935 732.455 709.903C732.359 709.872 732.271 709.822 732.196 709.756C732.12 709.69 732.058 709.609 732.014 709.519L731.938 709.376C731.894 709.285 731.832 709.205 731.756 709.138C731.681 709.072 731.593 709.022 731.498 708.989C731.403 708.957 731.303 708.944 731.203 708.951C731.103 708.958 731.006 708.985 730.916 709.03L729.349 709.831C729.177 709.916 729.024 710.035 728.898 710.18C728.773 710.325 728.677 710.495 728.617 710.677C728.557 710.86 728.533 711.054 728.548 711.246C728.563 711.438 728.616 711.625 728.704 711.796L745.832 746.016C746.008 746.363 746.312 746.626 746.68 746.747C747.047 746.869 747.447 746.84 747.793 746.666L761.854 739.538C762.198 739.361 762.459 739.055 762.58 738.685C762.701 738.316 762.672 737.913 762.499 737.565L745.363 703.328C745.276 703.155 745.157 703.002 745.012 702.876C744.867 702.75 744.698 702.654 744.516 702.594C744.334 702.533 744.142 702.51 743.95 702.524C743.759 702.539 743.573 702.591 743.402 702.678L741.701 703.564Z"
            fill="#2E76AB"
          />
          <path
            d="M737.015 706.156L734.897 707.229C734.749 707.305 734.689 707.487 734.764 707.637C734.839 707.787 735.02 707.847 735.169 707.772L737.287 706.698C737.436 706.622 737.495 706.44 737.421 706.29C737.346 706.14 737.164 706.08 737.015 706.156Z"
            fill="#E6E8EC"
          />
          <path
            d="M738.114 706.255C738.304 706.255 738.458 706.1 738.458 705.909C738.458 705.718 738.304 705.563 738.114 705.563C737.924 705.563 737.771 705.718 737.771 705.909C737.771 706.1 737.924 706.255 738.114 706.255Z"
            fill="#E6E8EC"
          />
          <path
            d="M753.768 834.818L748.53 976.287C748.53 976.287 766.128 970.383 768.851 974.811C771.575 979.239 765.918 903.958 765.918 903.958L753.768 834.818Z"
            fill="#5F5570"
          />
          <path
            opacity="0.15"
            d="M753.768 834.818L748.53 976.287C748.53 976.287 766.128 970.383 768.851 974.811C771.575 979.239 765.918 903.958 765.918 903.958L753.768 834.818Z"
            fill="black"
          />
          <path
            d="M754.605 1301.12C743.712 1301.69 700.698 1301.12 700.698 1301.12C700.698 1301.12 689.52 1292.41 688.682 1292.41C687.844 1292.41 687.29 1296.9 687.29 1296.9L669.693 1291.84V1282.85C669.693 1282.85 669.131 1257.25 674.436 1256.14C679.74 1255.02 703.212 1256.14 703.212 1256.14C704.05 1255.86 719.972 1271.04 724.438 1273.85C728.905 1276.66 728.067 1278.63 728.067 1278.63C728.067 1278.63 738.684 1287.62 747.064 1288.19C752.284 1288.54 758.158 1293.25 759.206 1296.9C759.843 1299.1 758.711 1300.91 754.605 1301.12Z"
            fill="#413B5B"
          />
          <path
            opacity="0.1"
            d="M754.605 1301.12C743.711 1301.69 700.698 1301.12 700.698 1301.12C700.698 1301.12 689.519 1292.41 688.681 1292.41C687.843 1292.41 687.29 1296.9 687.29 1296.9L669.692 1291.84V1283.03L686.167 1289.03L699.298 1296.9H759.205C759.842 1299.1 758.711 1300.91 754.605 1301.12Z"
            fill="black"
          />
          <g opacity="0.1">
            <path d="M705.692 1287.91C705.692 1287.91 719.1 1274.98 728.066 1278.63L705.692 1287.91Z" fill="black" />
            <path
              d="M705.692 1287.91C705.692 1287.91 719.1 1274.98 728.066 1278.63"
              stroke="black"
              strokeMiterlimit="10"
            />
          </g>
          <path
            d="M620.805 1240.39C621.366 1242.08 616.338 1244.33 616.338 1244.33V1266.54C616.338 1266.54 618.617 1279.87 615.324 1283.76C615.077 1284.08 614.765 1284.33 614.409 1284.52C614.053 1284.7 613.662 1284.8 613.263 1284.82C607.12 1285.09 593.713 1242.92 593.713 1242.92L592.875 1218.55L589.523 1216.22L584.771 1185.28H593.436C593.436 1185.28 594.35 1184.72 595.816 1183.96C600.006 1181.81 608.78 1178.06 613.548 1181.63L629.746 1218.37C629.746 1218.37 620.252 1238.7 620.805 1240.39Z"
            fill="#413B5B"
          />
          <path
            opacity="0.1"
            d="M615.324 1283.76C615.077 1284.08 614.765 1284.33 614.409 1284.52C614.053 1284.7 613.662 1284.8 613.263 1284.82C607.12 1285.09 593.713 1242.92 593.713 1242.92L592.875 1218.55L589.523 1216.22L584.771 1185.28H593.436C593.436 1185.28 594.35 1184.72 595.816 1183.96L597.903 1215.65L599.017 1242.92C599.017 1242.92 609.542 1272.61 615.324 1283.76Z"
            fill="black"
          />
          <path
            d="M770.736 1125.19C768.013 1129.19 750.206 1138.89 750.206 1138.89C750.206 1138.89 742.664 1139.32 733.865 1146.06C729.315 1149.55 713.502 1156.48 699.299 1162.36C686.033 1167.85 674.159 1172.42 674.159 1172.42L660.483 1188.45L650.067 1200.65C650.067 1200.65 643.783 1198.12 643.154 1202.76C642.526 1207.4 633.098 1212.67 633.308 1213.52C633.517 1214.36 629.746 1216.47 629.746 1218.37C629.746 1220.26 615.71 1204.66 615.92 1195.17C616.129 1185.68 608.797 1179.14 608.797 1179.14C608.797 1179.14 610.682 1175.77 613.615 1176.4C616.548 1177.04 619.062 1175.77 619.9 1174.72C620.738 1173.66 624.299 1176.19 625.975 1175.35C627.651 1174.51 634.355 1157.85 634.355 1157.85L660.475 1140.21L712.43 1105.15L714.826 1103.53C714.826 1103.53 721.74 1106.72 718.933 1080.6C718.388 1075.54 717.474 1069.39 716.083 1061.9C707.494 1015.72 738.29 1010.45 738.29 1010.45L765.315 1019.52L771.809 1029.64V1029.69L773.275 1092.05C773.275 1092.05 773.46 1121.18 770.736 1125.19Z"
            fill="#2D1456"
          />
          <path
            opacity="0.1"
            d="M699.089 1154.71C699.089 1154.71 699.173 1157.7 699.299 1162.36C686.033 1167.85 674.159 1172.42 674.159 1172.42L660.483 1188.45C660.257 1175.16 660.307 1157.91 660.483 1140.22L712.438 1105.16C706.011 1129.14 699.089 1154.71 699.089 1154.71Z"
            fill="black"
          />
          <path
            opacity="0.1"
            d="M771.784 1029.66V1029.71L731.142 1030.51C731.142 1030.51 724.019 1058.55 722.972 1064.46C722.712 1065.91 721.137 1072.11 718.908 1080.63C718.363 1075.56 717.449 1069.42 716.058 1061.93C707.469 1015.74 738.265 1010.47 738.265 1010.47L765.29 1019.54L771.784 1029.66Z"
            fill="black"
          />
          <path
            d="M664.732 953.116L659.494 1054.33C659.494 1054.33 655.723 1203 659.494 1212.7C663.265 1222.4 664.732 1237.58 664.732 1237.58C664.732 1237.58 662.427 1249.18 664.732 1252.97C667.036 1256.77 674.368 1260.99 674.159 1263.1C673.949 1265.2 696.575 1276.59 708.307 1258.46C708.307 1258.46 701.184 1248.34 702.65 1243.91C704.117 1239.48 702.022 1232.94 702.022 1232.94C702.022 1232.94 698.041 1220.5 698.041 1214.15C698.041 1207.8 696.575 1154.68 696.575 1154.68C696.575 1154.68 719.41 1070.34 720.457 1064.43C721.505 1058.53 728.628 1030.48 728.628 1030.48L771.784 1029.64C771.784 1029.64 770.527 999.483 768.013 992.946C765.499 986.409 753.139 938.541 753.139 938.541L664.732 953.116Z"
            fill="#2D1456"
          />
          <path
            d="M592.707 1052.34L588.961 1053.42L588.811 1057.15L701.117 1058.61V1057.14L592.707 1052.34Z"
            fill="#7B728F"
          />
          <path
            d="M725.175 741.925C708.835 775.285 718.983 782.261 720.6 783.121C717.139 781.502 672.156 760.229 678.073 754.831C681.919 751.313 685.212 736.013 687.148 725.047C688.296 718.502 688.966 713.5 688.966 713.5L736.17 722.213C731.594 729.636 727.958 736.173 725.175 741.925Z"
            fill="#C08B93"
          />
          <path
            opacity="0.1"
            d="M787.454 762.658L786.482 763.966L767.803 777.225L763.848 770.68C769.605 767.306 786.867 761.401 786.867 761.401L787.454 762.658Z"
            fill="black"
          />
          <path
            d="M804.674 793.066C802.998 798.97 774.716 793.066 774.716 793.066L771.783 788.427C771.783 788.427 771.49 787.836 770.996 786.875C769.186 783.34 764.803 774.973 762.993 773.489C760.688 771.591 787.713 762.312 787.713 762.312L795.993 780.447C798.033 781.828 799.916 783.432 801.607 785.23C803.702 787.516 805.437 790.375 804.674 793.066Z"
            fill="#E5E8EF"
          />
          <path
            d="M757.748 795.782C757.748 795.782 774.508 809.092 777.022 808.13C779.536 807.169 820.178 834.793 820.178 834.793C820.178 834.793 824.786 852.506 805.722 853.56C805.722 853.56 765.29 851.873 763.614 845.969C761.938 840.065 757.748 795.782 757.748 795.782Z"
            fill="#2D1456"
          />
          <path
            opacity="0.1"
            d="M712.078 769.027L693.852 788.005L719.41 951.64L729.466 945.736C729.466 945.736 755.443 957.334 757.538 946.579C759.633 935.825 759.055 893.44 759.055 893.44L755.653 816.869C755.653 816.869 743.711 790.088 743.711 789.245C743.711 788.401 726.491 775.327 726.491 775.327L718.362 769.001L712.078 769.027Z"
            fill="black"
          />
          <path
            d="M712.078 766.496L693.852 785.474L719.41 949.11L729.466 943.206C729.466 943.206 755.443 954.803 757.538 944.049C759.633 933.295 759.055 890.91 759.055 890.91L755.653 814.338C755.653 814.338 743.711 787.558 743.711 786.714C743.711 785.871 726.491 772.797 726.491 772.797L718.362 766.471L712.078 766.496Z"
            fill="#E5E8EF"
          />
          <path
            opacity="0.1"
            d="M713.126 769.237L708.098 779.57L713.126 784.909C713.126 784.909 731.142 821.533 727.581 843.253L731.352 914.738L743.502 926.758L753.139 915.556L748.53 850.608C748.53 850.608 736.17 797.047 723.181 780.388L719.41 765.627L713.126 769.237Z"
            fill="black"
          />
          <path
            d="M713.126 767.55L708.098 777.883L713.126 783.222C713.126 783.222 731.142 819.846 727.581 841.566L731.352 913.051L743.502 925.071L753.139 913.869L748.53 848.921C748.53 848.921 736.17 795.36 723.181 778.701L719.41 763.94L713.126 767.55Z"
            fill="#742F8C"
          />
          <path
            opacity="0.1"
            d="M736.169 722.213C731.594 729.636 727.991 736.173 725.175 741.925C722.209 742.806 719.133 743.252 716.041 743.25C705.684 743.25 699.717 736.038 693.851 728.379C692.511 726.642 688.103 727.046 687.147 725.005C688.295 718.46 688.966 713.458 688.966 713.458L736.169 722.213Z"
            fill="black"
          />
          <path
            d="M748.161 710.067C748.161 717.767 745.43 725.214 740.461 731.068C735.492 736.922 728.61 740.798 721.054 742C713.498 743.202 705.765 741.649 699.244 737.623C692.724 733.596 687.846 727.359 685.487 720.035C683.128 712.71 683.444 704.778 686.377 697.667C689.311 690.556 694.67 684.732 701.489 681.244C708.308 677.755 716.141 676.831 723.577 678.637C731.013 680.443 737.565 684.862 742.053 691.097C746.024 696.615 748.162 703.254 748.161 710.067Z"
            fill="#C08B93"
          />
          <path
            opacity="0.1"
            d="M705.793 782.101L679.397 750.048C679.397 750.048 676.958 749.061 685.196 740.382C685.196 740.382 715.447 764.117 717.324 768.149C719.201 772.181 705.793 782.101 705.793 782.101Z"
            fill="black"
          />
          <path
            d="M704.955 780.414L678.559 748.361C678.559 748.361 676.12 747.374 684.358 738.695C684.358 738.695 714.609 762.431 716.486 766.462C718.363 770.494 704.955 780.414 704.955 780.414Z"
            fill="#E5E8EF"
          />
          <path
            d="M771.783 984.41C771.783 984.41 766.756 981.373 766.756 977.788C766.756 974.204 764.242 923.595 764.242 923.595C764.242 923.595 760.555 893.39 756.7 869.384C754.437 855.239 752.116 843.236 750.474 840.857L750.407 840.756C746.007 835.063 746.845 807.228 719.401 766.53C719.77 766.783 729.231 773.463 736.161 776.82C737.571 777.534 739.051 778.099 740.577 778.507C746.862 779.983 767.392 787.996 766.764 800.86C766.135 813.723 768.23 843.245 768.23 843.245V903.747L771.783 984.41Z"
            fill="#2D1456"
          />
          <path
            d="M771.784 788.427C771.784 788.427 780.583 812.888 779.326 819.003C778.069 825.118 799.647 849.157 799.647 849.157L820.177 834.818C820.177 834.818 812.426 819.214 813.474 814.575C814.521 809.935 808.027 800.025 808.027 800.025L808.446 783.594C808.446 783.594 804.675 790.721 771.784 788.427Z"
            fill="#2D1456"
          />
          <path
            opacity="0.1"
            d="M742.053 691.097L726.131 691.705C724.576 691.694 723.027 691.89 721.522 692.287C715.832 694.049 713.209 700.139 713 705.614C712.79 711.088 709.648 717.22 703.556 717.701C702.95 717.804 702.327 717.665 701.821 717.313C701.435 716.899 701.178 716.38 701.084 715.82C700.21 712.63 698.859 709.592 697.078 706.811C694.564 707.267 692.704 709.671 692.05 712.184C691.397 714.698 691.573 717.346 691.581 719.953C691.589 723.263 691.272 726.566 690.634 729.813C688.037 726.419 686.135 722.538 685.04 718.398C683.946 714.257 683.679 709.938 684.257 705.693C684.835 701.448 686.246 697.361 688.407 693.669C690.568 689.978 693.437 686.756 696.846 684.19C700.255 681.624 704.137 679.766 708.266 678.724C712.395 677.681 716.689 677.476 720.898 678.118C725.106 678.761 729.146 680.239 732.782 682.468C736.418 684.696 739.578 687.629 742.078 691.097H742.053Z"
            fill="black"
          />
          <path
            d="M720.692 691.443C722.197 691.047 723.746 690.851 725.301 690.861L744.633 690.136C747.466 690.026 750.625 689.773 752.527 687.656C753.21 686.847 753.713 685.901 754.002 684.881C754.5 683.25 754.646 681.532 754.431 679.84C754.215 678.148 753.643 676.522 752.753 675.071C750.516 671.486 746.594 669.403 742.857 667.48C739.378 665.609 735.807 663.92 732.156 662.419C718.595 657.235 703.58 657.452 690.173 663.026C688.848 663.538 687.593 664.215 686.436 665.042C684.82 666.436 683.444 668.089 682.363 669.934L676.003 679.584C675.125 680.762 674.448 682.079 674 683.481C672.802 688.061 676.514 692.641 676.128 697.356C675.911 699.701 674.679 701.852 674.453 704.197C674.151 707.225 675.525 710.101 676.874 712.859L688.053 735.557C689.858 730.264 690.773 724.705 690.76 719.109C690.76 716.503 690.542 713.854 691.229 711.341C691.916 708.827 693.743 706.423 696.257 705.968C698.042 708.748 699.396 711.785 700.271 714.976C700.363 715.537 700.62 716.057 701.008 716.469C701.513 716.822 702.136 716.962 702.743 716.857C708.868 716.376 711.96 710.303 712.187 704.77C712.413 699.237 715.002 693.206 720.692 691.443Z"
            fill="#141137"
          />
          <path d="M588.962 1053.42L596.789 1051.17L714.801 1057.64L701.813 1059.33L588.962 1053.42Z" fill="#7B728F" />
          <path
            opacity="0.1"
            d="M588.962 1053.42L596.789 1051.17L714.801 1057.64L701.813 1059.33L588.962 1053.42Z"
            fill="black"
          />
          <path
            d="M718.011 1171.51L702.441 1170.05L696.978 1169.55V1082.38L698.419 1062.14L698.737 1057.64H714.801L718.011 1171.51Z"
            fill="#7B728F"
          />
          <path
            opacity="0.1"
            d="M713.754 1168.42L701.335 1167.03L696.978 1166.55V1083.91L698.126 1064.73L698.377 1060.45H711.19L713.754 1168.42Z"
            fill="black"
          />
          <path
            d="M628.59 1053.42C628.59 1053.42 636.341 1036.31 639.592 1035.78C642.844 1035.25 648.81 1035.78 648.81 1035.78L648.282 1040.74C648.282 1040.74 640.322 1041.37 637.808 1054.76L628.59 1053.42Z"
            fill="#7B728F"
          />
          <path
            opacity="0.1"
            d="M628.59 1053.42C628.59 1053.42 636.341 1036.31 639.592 1035.78C642.844 1035.25 648.81 1035.78 648.81 1035.78L648.282 1040.74C648.282 1040.74 640.322 1041.37 637.808 1054.76L628.59 1053.42Z"
            fill="black"
          />
          <path
            d="M658.656 1033.99C658.656 1033.99 679.497 1044.42 676.774 1056.65L665.461 1056.02C665.461 1056.02 660.014 1037.79 655.723 1036.83C651.433 1035.88 658.656 1033.99 658.656 1033.99Z"
            fill="#7B728F"
          />
          <path
            d="M736.17 868.768V869.384L735.751 939.621C735.751 939.621 725.067 998.664 722.134 1000.98C719.201 1003.3 654.886 996.978 654.886 996.978L625.766 799.392C625.557 765.653 649.229 766.707 649.229 766.707C652.372 761.646 667.455 757.64 667.455 757.64L675.835 749.416L676.103 749.036C676.66 748.2 677.378 747.486 678.215 746.936C679.941 745.932 681.039 747.256 681.668 748.564C681.951 749.178 682.17 749.819 682.321 750.478C716.268 775.538 736.17 868.768 736.17 868.768Z"
            fill="#2D1456"
          />
          <path
            opacity="0.1"
            d="M735.331 869.612V870.227C724.798 850.827 684.215 777.326 673.112 773.666L677.385 770.714C677.385 770.714 680.234 769.027 674.997 767.34C674.997 767.34 666.827 768.394 666.617 758.483L675.265 749.88L677.377 747.779L680.829 749.407C681.112 750.021 681.331 750.663 681.483 751.322C715.429 776.382 735.331 869.612 735.331 869.612Z"
            fill="black"
          />
          <path
            d="M736.169 868.768V869.384C725.636 849.984 685.053 776.483 673.949 772.822L678.223 769.87C678.223 769.87 681.072 768.183 675.835 766.496C675.835 766.496 667.665 767.55 667.455 757.64L676.103 749.036L678.215 746.936L681.667 748.564C681.95 749.178 682.169 749.819 682.321 750.478C716.267 775.538 736.169 868.768 736.169 868.768Z"
            fill="#2D1456"
          />
          <path
            opacity="0.1"
            d="M751.32 841.667L751.253 841.566C746.854 835.872 747.692 808.038 720.248 767.34C720.617 767.593 730.078 774.273 737.008 777.63L735.072 784.057L739.262 786.31L751.32 841.667Z"
            fill="black"
          />
          <path
            d="M750.482 840.824L750.415 840.722C746.016 835.029 746.854 807.194 719.41 766.496C719.779 766.749 729.24 773.43 736.17 776.787L734.234 783.214L738.424 785.466L750.482 840.824Z"
            fill="#433A59"
          />
          <path
            opacity="0.1"
            d="M718.203 760.001L716.485 767.306C716.485 767.306 717.742 774.619 725.276 775.251L726.491 771.768C726.491 771.768 718.362 766.521 718.203 760.001Z"
            fill="black"
          />
          <path
            d="M718.203 759.158L716.485 766.462C716.485 766.462 717.742 773.775 725.276 774.408L726.491 770.924C726.491 770.924 718.362 765.678 718.203 759.158Z"
            fill="#E5E8EF"
          />
          <path
            opacity="0.1"
            d="M707.368 1058.82L702.441 1170.05L696.978 1169.55V1082.38L698.419 1062.14L707.368 1058.82Z"
            fill="black"
          />
          <path d="M590.084 1101.78L586.732 1161.95L700.698 1171.51L705.692 1058.82L590.084 1101.78Z" fill="#7B728F" />
          <path
            opacity="0.1"
            d="M587.57 1108.25L589.799 1055.11L706.53 1060.51L700.974 1116.68L587.57 1108.25Z"
            fill="black"
          />
          <path d="M586.732 1106.56L588.961 1053.42L705.692 1058.82L700.136 1115L586.732 1106.56Z" fill="#7B728F" />
          <path d="M649.857 1106.63H635.821V1123.08H649.857V1106.63Z" fill="#51405B" />
          <path
            d="M637.917 998.875L635.822 1004.57C635.822 1004.57 631.422 1035.78 636.869 1039.57C642.316 1043.37 658.447 1043.58 659.285 1041.68C660.123 1039.78 665.989 1018.28 665.989 1018.28C665.989 1018.28 671.226 1034.09 673.95 1032.83C676.673 1031.56 667.665 1001.5 667.665 1001.5L637.917 998.875Z"
            fill="#C08B93"
          />
          <path
            opacity="0.1"
            d="M635.821 975.258V1005.41C635.821 1005.41 658.028 1009.63 667.664 1002.34C667.664 1002.34 658.656 973.149 662.008 965.769C665.36 958.388 635.821 975.258 635.821 975.258Z"
            fill="black"
          />
          <path
            d="M635.821 974.414V1004.57C635.821 1004.57 658.028 1008.79 667.664 1001.5C667.664 1001.5 658.656 972.306 662.008 964.925C665.36 957.545 635.821 974.414 635.821 974.414Z"
            fill="#E5E8EF"
          />
          <path
            opacity="0.1"
            d="M633.308 797.916L627.442 801.079C627.442 801.079 626.395 813.731 625.766 815.418C625.138 817.105 625.766 834.185 625.766 834.185L625.481 868.768C625.481 868.768 624.576 887.114 625.481 893.651C626.386 900.188 627.4 925.071 627.4 925.071C627.4 925.071 633.065 949.321 630.97 957.966C628.875 966.612 631.18 986.012 634.741 984.325C638.302 982.638 671.193 976.101 672.869 974.836C674.545 973.571 673.707 961.762 672.869 960.286C672.031 958.81 667.003 938.777 667.422 934.138C667.841 929.499 665.956 888.801 665.956 888.801C665.956 888.801 669.098 845.362 670.355 835.24C671.612 825.118 667.841 795.385 664.489 794.964C661.137 794.542 651.325 771.557 633.308 797.916Z"
            fill="black"
          />
          <path
            d="M631.631 796.229L625.765 799.392C625.765 799.392 624.718 812.044 624.089 813.731C623.461 815.418 624.089 832.499 624.089 832.499L623.805 867.081C623.805 867.081 622.9 885.427 623.805 891.964C624.71 898.501 625.724 923.384 625.724 923.384C625.724 923.384 631.388 947.634 629.293 956.279C627.198 964.925 629.503 984.325 633.064 982.638C636.626 980.951 669.516 974.414 671.192 973.149C672.868 971.884 672.03 960.075 671.192 958.599C670.354 957.123 665.326 937.09 665.745 932.451C666.164 927.812 664.279 887.114 664.279 887.114C664.279 887.114 667.421 843.675 668.678 833.553C669.935 823.431 666.164 793.698 662.813 793.277C659.461 792.855 649.648 769.87 631.631 796.229Z"
            fill="#2D1456"
          />
          <g opacity="0.1">
            <path
              opacity="0.1"
              d="M694.992 702.805C692.478 703.26 690.617 705.664 689.964 708.178C689.31 710.691 689.486 713.34 689.495 715.946C689.511 721.542 688.599 727.101 686.796 732.394L675.609 709.696C675.391 709.249 675.165 708.785 674.947 708.321C675.465 709.883 676.107 711.401 676.866 712.859L688.053 735.557C689.856 730.264 690.768 724.705 690.752 719.109C690.752 716.503 690.542 713.854 691.221 711.341C691.9 708.827 693.735 706.423 696.249 705.968C697.06 707.247 697.785 708.58 698.419 709.958C697.568 707.443 696.417 705.041 694.992 702.805Z"
              fill="black"
            />
            <path
              opacity="0.1"
              d="M752.954 675.434C753.446 677.509 753.377 679.679 752.753 681.718C752.461 682.739 751.955 683.685 751.27 684.493C749.368 686.61 746.242 686.863 743.376 686.973L724.053 687.698C722.495 687.688 720.942 687.883 719.435 688.28C713.754 690.043 711.122 696.133 710.913 701.607C710.704 707.081 707.561 713.213 701.469 713.694C700.863 713.798 700.24 713.659 699.734 713.306C699.927 713.854 700.111 714.411 700.271 714.993C700.357 715.554 700.611 716.075 701 716.486C701.505 716.838 702.128 716.978 702.734 716.874C708.868 716.393 711.952 710.32 712.178 704.787C712.405 699.254 715.019 693.223 720.701 691.46C722.208 691.063 723.76 690.868 725.318 690.878L744.642 690.153C747.474 690.043 750.633 689.79 752.535 687.673C753.221 686.865 753.726 685.919 754.019 684.898C754.494 683.331 754.644 681.682 754.461 680.055C754.278 678.427 753.765 676.854 752.954 675.434Z"
              fill="black"
            />
          </g>
          <path
            opacity="0.1"
            d="M721.488 1021.39C721.488 1021.39 728.745 1017.59 731.544 1017.8C734.343 1018.01 759.474 1050.18 759.474 1050.18L721.488 1021.39Z"
            fill="black"
          />
          <path
            opacity="0.1"
            d="M647.051 803.668C647.051 803.668 633.786 809.37 634.138 813.309C634.49 817.248 647.051 803.668 647.051 803.668Z"
            fill="black"
          />
          <path
            opacity="0.1"
            d="M640.59 822.309C640.59 822.309 626.671 840.225 629.746 840.824C632.822 841.423 640.59 822.309 640.59 822.309Z"
            fill="black"
          />
          <path
            opacity="0.1"
            d="M687.148 849.157C687.148 849.157 688.421 889.223 678.215 894.284L687.148 849.157Z"
            fill="black"
          />
          <path
            opacity="0.1"
            d="M634.104 956.136C634.104 956.136 643.925 950.519 646.179 951.64C648.433 952.762 634.104 956.136 634.104 956.136Z"
            fill="black"
          />
          <path
            opacity="0.1"
            d="M635.821 963.905C635.821 963.905 642.022 964.352 644.964 963.061C647.905 961.771 635.821 963.905 635.821 963.905Z"
            fill="black"
          />
          <path
            opacity="0.1"
            d="M783.851 816.371C783.851 816.371 791.543 838.614 795.976 838.614L783.851 816.371Z"
            fill="black"
          />
          <path
            opacity="0.1"
            d="M674.461 1242.36C674.461 1242.36 688.891 1238.42 691.019 1242.36C693.148 1246.3 674.461 1242.36 674.461 1242.36Z"
            fill="black"
          />
          <path
            opacity="0.1"
            d="M628.59 1183.96C628.59 1183.96 624.995 1189.5 629.747 1191.19C634.498 1192.88 628.59 1183.96 628.59 1183.96Z"
            fill="black"
          />
          <path
            opacity="0.1"
            d="M724.438 1106.63C724.438 1106.63 735.331 1116.4 740.476 1116.68C745.622 1116.97 724.438 1106.63 724.438 1106.63Z"
            fill="black"
          />
        </BusinessMan>
        <path
          d="M1603.14 479.27C1564.29 439.635 1564.29 375.365 1603.14 335.73C1642 296.09 1705 296.09 1743.86 335.73C1782.71 375.365 1782.71 439.635 1743.86 479.27C1705 518.91 1642 518.91 1603.14 479.27Z"
          fill="url(#paint9_linear)"
        />

        <defs>
          <linearGradient
            id="paint1_linear"
            x1="1701.97"
            y1="16.9298"
            x2="1377.24"
            y2="1081.84"
            gradientUnits="userSpaceOnUse">
            <stop offset="0.464119" stopColor={bIsDark ? palette.darkPurple : '#481471'} />
            <stop offset="0.966667" stopColor={bIsDark ? palette.darkPurple : '#812DB6'} />
          </linearGradient>
          <linearGradient
            id="paint2_linear"
            x1="873.651"
            y1="198"
            x2="873.651"
            y2="355.951"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#4E68DC" />
            <stop offset="1" stopColor="#4F177A" stopOpacity="0.15" />
          </linearGradient>
          <linearGradient
            id="paint3_linear"
            x1="1064.1"
            y1="214.101"
            x2="1064.1"
            y2="359.013"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#4F44B0" />
            <stop offset="1" stopColor="#4F44B0" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint4_linear"
            x1="947.07"
            y1="204.139"
            x2="947.07"
            y2="323.764"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#AB69EC" />
            <stop offset="1" stopColor="#4E41AB" />
          </linearGradient>
          <linearGradient
            id="paint5_linear"
            x1="1006.83"
            y1="207.176"
            x2="1006.83"
            y2="332.118"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#8163F8" />
            <stop offset="1" stopColor="#4F44B0" stopOpacity="0.29" />
          </linearGradient>
          <linearGradient
            id="paint6_linear"
            x1="1260.8"
            y1="351.621"
            x2="1151.67"
            y2="275.436"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#731EB6" />
            <stop offset="1" stopColor="#B21EB6" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint7_linear"
            x1="803.5"
            y1="790.5"
            x2="558.999"
            y2="1096"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#67A2DE" />
            <stop offset="1" stopColor="#744CB8" />
          </linearGradient>
          <linearGradient
            id="paint8_linear"
            x1="702.717"
            y1="1301.12"
            x2="702.717"
            y2="656"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#808080" stopOpacity="0.25" />
            <stop offset="0.54" stopColor="#808080" stopOpacity="0.12" />
            <stop offset="1" stopColor="#808080" stopOpacity="0.1" />
          </linearGradient>
          <linearGradient
            id="paint9_linear"
            x1="1559.74"
            y1="530.158"
            x2="1799.75"
            y2="331.635"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#5EDDF9" />
            <stop offset="1" stopColor="#7B21A6" />
          </linearGradient>
          <clipPath id="clip0">
            <rect x="684" y="198" width="421" height="159" fill="white" />
          </clipPath>
          <clipPath id="clip1">
            <rect
              width="65.2141"
              height="74.6389"
              transform="matrix(0.767627 0.640897 -0.634982 0.772527 1087.39 136)"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip2">
            <rect x="429" y="656" width="732" height="676" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Container>
  );
};

export default withContent(withTheme(withStyles(styles)(ContactPageShape)));
